import React, { Component } from "react";
import FormSet, { SubFormDefinition } from "./FormSet";

export interface FormSetProps {
    field?: any;
    form?: any;
    givenid: string;
    onChange?: (e) => void;
    formSetLabel?: string;
    subFormTypes: SubFormDefinition[];
    initialValues: any[];
    extraFields?: any;
    subsidiary?: any;
    isConfig?: boolean;
}

export default class BaseFormSet extends Component<FormSetProps, {}> {
    handleOnChange = formEvent => {
        this.props.form.setFieldValue(this.props.field.name, formEvent.values);
    };

    render() {
        return (
            <div id={this.props.givenid + "FormSet"}>
                <FormSet
                    onChange={this.handleOnChange}
                    subFormTypes={this.props.subFormTypes}
                    formSetLabel={this.props.formSetLabel}
                    initialValues={
                        this.props.field.value || this.props.initialValues
                    }
                    extraFields={this.props.extraFields}
                    subsidiary={this.props.subsidiary}
                    isConfig={this.props.isConfig}
                />
            </div>
        );
    }
}
